import Speakers from './speakers'

export default Speakers
